import { getLocale } from "../runtime";

const da_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Verificerer køb, vent venligst...`
};

const en_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Verifying purchase, please wait...`
};

const es_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Verificando compra, por favor espera...`
};

const fi_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vahvistetaan ostoa, odota hetki...`
};

const nb_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Verifiserer kjøp, vennligst vent...`
};

const sv_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Verifierar köp, vänligen vänta...`
};

const verifyingpurchase = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_verifyingpurchase(inputs)
	if (locale === "en") return en_verifyingpurchase(inputs)
	if (locale === "es") return es_verifyingpurchase(inputs)
	if (locale === "fi") return fi_verifyingpurchase(inputs)
	if (locale === "nb") return nb_verifyingpurchase(inputs)
	if (locale === "sv") return sv_verifyingpurchase(inputs)
	return "verifyingPurchase";
};

export { verifyingpurchase as "verifyingPurchase" };